/**
 * Termini e Condizioni di Utilizzo del Servizio - Pagina dedicata
 * Content from Termini e condizioni di servizio.rtf – versione italiana + English
 */

import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  AppBar,
  Toolbar,
  Divider
} from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';

interface TerminiCondizioniProps {
  onBack: () => void;
}

const TerminiCondizioni: React.FC<TerminiCondizioniProps> = ({ onBack }) => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9fa' }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: '#003399',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <Toolbar>
          <Button startIcon={<BackIcon />} onClick={onBack} sx={{ color: 'white' }}>
            Indietro
          </Button>
          <Typography variant="h6" sx={{ ml: 2, color: 'white' }}>
            Termini e Condizioni
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#003399', mb: 1, textAlign: 'center' }}>
            TERMINI E CONDIZIONI DI UTILIZZO DEL SERVIZIO
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center', fontStyle: 'italic' }}>
            (Versione italiana – Legalmente vincolante)
          </Typography>

          <Divider sx={{ mb: 4 }} />

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 1 – Parti e Identificazione del Fornitore
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Il presente documento disciplina l&apos;uso del sito web e della piattaforma digitale <strong>Erasmus+ Project Generator</strong> (di seguito &quot;Servizio&quot; o &quot;Piattaforma&quot;), di proprietà di:<br /><br />
            <strong>Ing. Francesco Marinuzzi</strong><br />
            Via Vincenzo Tiberio, n. 64 – 00100 Roma (Italia)<br />
            P.IVA: 09728030587<br />
            Email: info@marinuzzi.it
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Il presente accordo costituisce un contratto vincolante tra l&apos;Utente e il Fornitore. L&apos;utilizzo della Piattaforma implica l&apos;accettazione integrale dei presenti Termini e Condizioni.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 2 – Oggetto del Contratto
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Il Servizio consiste in una piattaforma web che fornisce strumenti digitali e funzionalità di generazione automatica di progetti Erasmus+ e contenuti correlati, anche a supporto della progettazione accademica e professionale. Il Fornitore concede all&apos;Utente una <strong>licenza d&apos;uso limitata, non esclusiva, non trasferibile e revocabile</strong> per accedere e utilizzare la Piattaforma, in base al piano scelto (gratuito o a pagamento).
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 3 – Piani, Corrispettivi e Modalità di Pagamento
          </Typography>
          <Box component="ol" sx={{ mb: 3, pl: 3, color: '#444' }}>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>L&apos;accesso iniziale alla Piattaforma può avvenire in modalità gratuita (free trial), con funzionalità limitate.</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>I piani a pagamento garantiscono un utilizzo esteso e avanzato del Servizio, con prezzi e condizioni indicati nella sezione dedicata del sito.</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Il pagamento avviene tramite i canali elettronici indicati e si intende perfezionato al momento dell&apos;accredito.</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Il Fornitore potrà modificare prezzi o condizioni, con preavviso di almeno 30 (trenta) giorni per gli Utenti attivi.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 4 – Obblighi e Responsabilità dell&apos;Utente
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: '#444' }}>
            L&apos;Utente è tenuto a utilizzare la Piattaforma in modo conforme alla legge, all&apos;ordine pubblico e al buon costume, evitando qualsiasi uso illecito o lesivo di diritti altrui. È vietato:
          </Typography>
          <Box component="ul" sx={{ mb: 2, pl: 3, color: '#444' }}>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>caricare contenuti illeciti, falsi, diffamatori, discriminatori o che violino diritti di proprietà intellettuale;</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>eseguire attività di reverse engineering, manomissione o accesso non autorizzato ai sistemi informatici;</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>utilizzare la Piattaforma per attività fraudolente o concorrenziali.</Typography></li>
          </Box>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            L&apos;Utente riconosce che i contenuti generati automaticamente dal Servizio <strong>non costituiscono consulenza ufficiale o garanzia di accuratezza</strong>, e ne assume la piena responsabilità d&apos;uso.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 5 – Proprietà Intellettuale
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Tutti i diritti sul software, sul codice, sul design e sui marchi relativi a Erasmus+ Project Generator sono di esclusiva proprietà del Fornitore. L&apos;Utente conserva i diritti sui propri contenuti caricati e può utilizzare liberamente gli output generati, nel rispetto della legge e del presente Contratto.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 6 – Trattamento dei Dati Personali (GDPR)
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Il trattamento dei dati personali è disciplinato dall&apos;<strong>Informativa Privacy</strong> disponibile sul sito. Per le attività di trattamento effettuate tramite la Piattaforma, Erasmus+ Project Generator agisce come <strong>Titolare del trattamento</strong>. Gli utenti che trattano dati di terzi tramite la Piattaforma assumono il ruolo di Titolari autonomi e garantiscono la liceità dei trattamenti effettuati.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 7 – Limitazione di Responsabilità
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: '#444' }}>
            Il Fornitore non è responsabile per:
          </Typography>
          <Box component="ul" sx={{ mb: 2, pl: 3, color: '#444' }}>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>eventuali interruzioni del Servizio, malfunzionamenti o perdita di dati;</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>utilizzo improprio, illecito o non autorizzato del Servizio da parte dell&apos;Utente;</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>danni indiretti, perdita di profitti o reputazione.</Typography></li>
          </Box>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            La responsabilità complessiva del Fornitore non potrà comunque superare l&apos;importo corrisposto dall&apos;Utente nei 12 mesi precedenti.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 8 – Durata, Recesso e Sospensione
          </Typography>
          <Box component="ol" sx={{ mb: 3, pl: 3, color: '#444' }}>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Il contratto è a tempo indeterminato per i piani gratuiti e a termine per quelli a pagamento.</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>L&apos;Utente può recedere in ogni momento inviando comunicazione a info@marinuzzi.it.</Typography></li>
            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Il Fornitore può sospendere o terminare l&apos;accesso in caso di violazione dei Termini o mancato pagamento.</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 9 – Modifiche ai Termini
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            I presenti Termini possono essere aggiornati in qualsiasi momento, previa pubblicazione sul sito e notifica via e-mail agli utenti registrati. L&apos;uso continuato del Servizio dopo la modifica costituisce accettazione implicita.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 10 – Legge Applicabile e Foro Competente
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            Il presente Contratto è regolato dalla <strong>legge italiana</strong>. Per ogni controversia sarà competente in via esclusiva il <strong>Foro di Roma</strong>, salvo diversa previsione inderogabile per i consumatori.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: '#003399', mb: 1 }}>
            Art. 11 – Accettazione
          </Typography>
          <Typography variant="body1" sx={{ mb: 5, lineHeight: 1.8, color: '#444' }}>
            Selezionando la casella &quot;Accetto i Termini e Condizioni d&apos;Uso&quot;, l&apos;Utente dichiara di aver letto, compreso e accettato integralmente il presente documento e l&apos;Informativa Privacy collegata.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h5" sx={{ fontWeight: 700, color: '#003399', mb: 3, textAlign: 'center' }}>
            TERMS AND CONDITIONS OF USE (English Version)
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            This agreement governs the use of the website and digital platform <strong>Erasmus+ Project Generator</strong> (the &quot;Service&quot;), owned by Erasmus+ Project Generator – Via Vincenzo Tiberio, n. 64 – 00100 Rome (Italy) – VAT No.: 09728030587 – Email: info@marinuzzi.it. By using the Service, the User agrees to be bound by these Terms and Conditions in their entirety.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: '#444' }}>
            The Service provides a web platform offering digital tools for automatic generation of Erasmus+ projects and related materials. The Provider grants the User a limited, non-exclusive, non-transferable and revocable license to access and use the Platform according to the selected plan (free or paid). Plans, fees and payment: initial access may be free (trial); paid plans grant enhanced features; payments are processed through electronic systems; the Provider may change prices with at least 30 days&apos; notice. User obligations: use lawfully and ethically; no unlawful content, reverse engineering, or fraudulent use; generated content does not constitute official advice. Intellectual property: all rights belong to the Provider; Users retain rights over uploaded content. Data processing complies with the Privacy Policy; the Provider acts as Data Controller. Limitation of liability: the Provider is not liable for service interruptions, unauthorized use, or indirect damages; liability shall not exceed fees paid in the previous 12 months. Duration and termination: open-ended for free plans, fixed-term for paid; User may terminate at any time (info@marinuzzi.it); Provider may suspend for breaches or non-payment. Amendments: Terms may be updated by posting online and notifying by email; continued use constitutes acceptance. Governing law: Italian law; exclusive jurisdiction of the Court of Rome, except as required by consumer protection law.
          </Typography>

          <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Button
              variant="contained"
              onClick={onBack}
              sx={{ bgcolor: '#003399', px: 4, py: 1.5, '&:hover': { bgcolor: '#002266' } }}
            >
              Torna alla home
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TerminiCondizioni;
